// extracted by mini-css-extract-plugin
module.exports = {"root":"ScreenLoader_root__SIV_A"};